import { commonEnv } from 'src/environments/environment.common';
import { Environment } from '../types';

const env: Partial<Environment> = {
    production: false,
    environment: 'develop',
    googleMapApiKey: 'AIzaSyArxQrWxUPBL51fnryz3gpioSNiLLkOagQ',
    addressValidationApiKey: 'AIzaSyCzZNvhui9pQi995yGGQEDmOIIR-GvdD3k',
    projects: {
        sprintPay: 'https://qa.sprintpay.cargosprint.com',
    },
    authenticationURL: 'https://auth-develop.cargosprintgroup.com',
    appSentryDsn: 'https://6baab08af5b687238cc219323689a336@o4507493303582720.ingest.us.sentry.io/4508774795706368',
    googleMapIdDark: '7126ac2935cd1322',
    googleMapIdLight: '8047dca5e3e5d595',
    statsigSdkKey: 'client-TMqqFjGeGc0kG9eRXJ6v4lOagxLOSuBdNvCfH6RjsO1',
    keycloakConfig: {
        url: 'https://sso-qa.cargosprint.com',
        realm: 'unified-portal-new',
        clientId: 'test-ui',
    },
    applicationName: 'bdp',
};

export const environment = Object.assign(commonEnv, env);
